import { FileSpreadsheet, FileText, BookOpen, Book, Map as MapIcon, Layers } from "lucide-react";

export const RESOURCE_TYPES = ["Libro", "Ebook", "Guía", "Plantilla Excel", "Documento PDF", "Material complementario"];

export const RESOURCE_ICONS = {
  "Libro": Book,
  "Ebook": BookOpen,
  "Guía": MapIcon,
  "Plantilla Excel": FileSpreadsheet,
  "Documento PDF": FileText,
  "Material complementario": Layers,
};

export const downloadUrl = (id) => `${window.location.origin}/api/recursos/${id}/descargar`;

export const downloadLabel = (r) => {
  const ext = (r.file_name || "").split(".").pop().toUpperCase();
  if (["XLSX", "XLS", "CSV"].includes(ext)) return "Descargar Excel";
  if (ext === "PDF") return "Descargar PDF";
  return "Descargar";
};
